// FILE: src/components/NextUpCard.js
//
// Compact "Next Up" card in the primary column — shows today's planned
// activity from the study plan and a Start Now CTA. Falls back to a
// "plan up to date" state when there's nothing queued.

import React from 'react';
import DashCard from './DashCard';
import styles from './NextUpCard.module.css';

export default function NextUpCard({
  activity,
  onStartSession,
  onViewPlan,
}) {
  if (!activity) {
    return (
      <DashCard eyebrow="Next Up" eyebrowIcon="◎" testId="dashboard-next-up">
        <div className={styles.empty}>Your plan is up to date.</div>
        <button type="button" className={styles.ghostBtn} onClick={onViewPlan}>
          View study plan
        </button>
      </DashCard>
    );
  }

  const title = activity.description?.split(' — ')[0] || (activity.activity_type || 'Practice').replace(/_/g, ' ');
  const phase = activity.focus_phase || null;
  const meta = formatMeta(activity);

  return (
    <DashCard eyebrow="Next Up" eyebrowIcon="◎" testId="dashboard-next-up">
      <div className={styles.title}>{capitalize(title)}</div>
      {phase && <div className={styles.sub}>{phase}</div>}
      {meta && <div className={styles.meta}>{meta}</div>}
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.primaryBtn}
          onClick={onStartSession}
          data-testid="dashboard-start-next"
        >Start Now</button>
        <button
          type="button"
          className={styles.ghostBtn}
          onClick={onViewPlan}
          data-testid="dashboard-view-plan"
        >View Study Plan</button>
      </div>
    </DashCard>
  );
}

function capitalize(s) {
  if (!s) return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function formatMeta(a) {
  const bits = [];
  if (typeof a.recommended_count === 'number') bits.push(`${a.recommended_count} questions`);
  if (typeof a.target_minutes === 'number')    bits.push(`~${a.target_minutes} min`);
  return bits.join(' • ');
}
